import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { uniqueId, noop, pick } from 'lodash';

import { withFormGroup } from '@dbk/ui-forms';
import { bemHelper } from '@dbk/ui-react-utils';

import { DropdownPropTypes, DropdownDefaultProps } from './dropdown-common';

import styles from './dropdown.css';

import DropdownList from './dropdown-list';
import DropdownField from './dropdown-field';

const bem = bemHelper(styles, 'dropdown');

class Dropdown extends PureComponent {
  static propTypes = {
    ...DropdownPropTypes,
    tabIndex: PropTypes.number,
    id: PropTypes.string,
    bordered: PropTypes.bool,
    className: PropTypes.string,
    required: PropTypes.bool,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    /* see http://tether.io/#options */
    tetherProps: PropTypes.object,
  };

  static defaultProps = {
    ...DropdownDefaultProps,
    tabIndex: 0,
    id: uniqueId('dropdown_'),
    bordered: false,
    messages: undefined,
    className: undefined,
    required: false,
    onBlur: noop,
    onFocus: noop,
    tetherProps: {},
    isPortfolio: false,
  };

  static contextTypes = {
    inverse: PropTypes.bool,
  };

  static propOptions = {
    size: ['small', 'medium', 'large'],
  };

  render() {
    const {
      id,
      tabIndex,
      selected,
      size,
      fullWidth,
      disabled,
      error,
      success,
      required,
      bordered,
      className
    } = this.props;

    const childId = `${id}-selected-value-label`;

    const dropdownClasses = classnames(
      bem(),
      bem('target'),
      bem(null, size),
      {
        [bem(null, 'full-width')]: fullWidth,
        [bem(null, 'disabled')]: disabled,
        [bem(null, 'error')]: error,
        [bem(null, 'success')]: success,
        [bem(null, 'inverse')]: this.context.inverse,
        [bem(null, 'no-selection')]: !selected,
        [bem(null, 'required')]: required && !selected && !disabled,
        [bem(null, 'bordered')]: bordered,
      },
      className
    );

    const listProps = pick(this.props, [
      'options',
      'onChange',
      'renderOption',
      'fullWidth',
      'disabled',
      'selected',
      'defaultLabel',
      'formatInputLabel',
      'size',
      'className',
      'onBlur',
      'onFocus',
      'tetherProps',
      'onDropdownOpen',
      'onDropdownClose',
      'isPortfolio'
    ]);

    const fieldProps = pick(this.props, [
      'renderSelectedOption',
      'selected',
      'testID',
    ]);

    return (
      <DropdownList id={id} {...listProps}>
        <DropdownField
          id={id}
          childId={childId}
          dropdownClasses={dropdownClasses}
          tabIndex={!disabled ? tabIndex : ''}
          {...fieldProps}
        />
      </DropdownList>
    );
  }
}

export default withFormGroup(Dropdown);
